var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 148,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_svg__a)",
    d: "M135.49 148H20.51C9.18 148 0 137.32 0 124.14c0-9.37 4.71-17.87 12.05-21.73l57.49-30.28c5.38-2.83 11.55-2.83 16.93 0l57.49 30.28c7.34 3.86 12.05 12.37 12.05 21.73 0 13.18-9.18 23.86-20.51 23.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_svg__b)",
    d: "M78 0c22.09 0 40 17.82 40 45.64S100.09 96 78 96 38 73.45 38 45.64 55.91 0 78 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__a",
    x1: 78,
    x2: 78,
    y1: 86.21,
    y2: 146.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61ADD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__b",
    x1: 78,
    x2: 78,
    y1: 95.1,
    y2: 0.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgIcon;